var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.752 11.086c-.32 0-.595-.114-.823-.343a1.124 1.124 0 01-.343-.824V4.086c0-.321.114-.596.343-.824.228-.229.502-.343.823-.343H9.92c.32 0 .595.114.824.343.229.228.343.503.343.824v5.833c0 .32-.114.595-.343.824a1.125 1.125 0 01-.824.343H8.752zm-4.666 0c-.321 0-.596-.114-.824-.343a1.124 1.124 0 01-.343-.824V4.086c0-.321.114-.596.343-.824.228-.229.503-.343.824-.343h1.166c.321 0 .596.114.825.343.228.228.342.503.342.824v5.833c0 .32-.114.595-.342.824a1.125 1.125 0 01-.825.343H4.086z"
  })));
}
export default SvgPause;